import { render } from "./Relation.vue?vue&type=template&id=55f46475&scoped=true&ts=true"
import script from "./Relation.vue?vue&type=script&lang=ts"
export * from "./Relation.vue?vue&type=script&lang=ts"

import "./Relation.vue?vue&type=style&index=0&id=55f46475&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f46475"]])

export default __exports__